import { AutocompleteInput, FormDataConsumer, ReferenceInput, TextInput } from "react-admin";

export const SubCategoryTagSelect = () => {
  return (
    <>
      {/* If want custom layout: https://stackoverflow.com/questions/60175609/arrayinput-with-simpleformiterator-of-react-admin-generate-wrong-output */}
      {/* <SelectInput fullWidth source="tag_type" choices={tagTypes} label="Type" /> */}
      <TextInput fullWidth source="tag_type" defaultValue="sub_category" label="Type" disabled />
      <FormDataConsumer label="Value" fullWidth>
        {() => {
          return (
            <ReferenceInput
              fullWidth
              label="Value"
              source={"sub_category_tag_id"}
              reference="mpm-row-tag-autocomplete"
              filter={{ tag_type: "sub_category" }}
              filterToQuery={(searchText) => {
                if (searchText) {
                  return {
                    name_tc: searchText,
                  };
                }
                return {};
              }}
            >
              <AutocompleteInput
                // source="sub_category_tag_id"

                fullWidth
                optionText={(record) => {
                  if (record == null) {
                    return null;
                  }
                  return record.name_tc + " " + record.name_en;
                }}
              />
            </ReferenceInput>
          );
        }}
      </FormDataConsumer>
    </>
  );
};
